import { FaqProps } from "@ft/components/common/Faq";

const textToUppercaseFaqData: FaqProps[] = [
  {
    question: "What does this tool do?",
    ans: "This tool converts any text you enter from lowercase letters to uppercase letters.",
  },
  {
    question: "Is this tool free to use?",
    ans: "Yes, this tool is completely free to use with no limitations.",
  },
  {
    question: "What is the maximum amount of text I can convert?",
    ans: "You have the freedom to convert text without constraints. However, for extensive conversions, it's advisable to break the text into smaller segments for smoother processing.",
  },
  {
    question: "Does this tool preserve formatting?",
    ans: "No, this tool only changes the case of the letters and does not preserve any formatting like bold, italics, or underline.",
  },
  {
    question: "What happens to special characters and symbols?",
    ans: "Special characters and symbols will remain unchanged during the conversion.",
  },
  {
    question: "Is my text saved on the server?",
    ans: "No, your text is not saved on the server for privacy and security reasons.",
  },
  {
    question: "How accurate is this tool?",
    ans: "This tool is highly accurate and will convert your text to uppercase letters flawlessly.",
  },
  {
    question: "Do I need to download any software to use this tool?",
    ans: "No, this tool is web-based and can be used directly from your browser without any downloads.",
  },
  {
    question: "Can I use this tool on mobile devices?",
    ans: "Yes",
  },
];

export default textToUppercaseFaqData;
